export default class MemberForm {
  constructor(data = {}) {
    this.title = data.title || null
    this.firstName = data.firstName || null
    this.lastName = data.lastName || null
    this.email = data.email || null
    this.country = data.country || null
  }

  static validator(titles = [], countries = []) {
    const titleList = titles.map((t) => t.value).join(',')
    const countryList = countries.map((c) => c.id).join(',')

    return {
      title: `required|included:${titleList}`,
      name: 'required|min:3|max:255',
      email: 'required|email|unique',
      country: `required|included:${countryList}`,
    }
  }
}
